// @flow
import { velocityHelpers } from 'velocity-react';

export const FadeIn = velocityHelpers.registerEffect({
    calls: [[{ opacity: [1, 0] }, 1, { easing: 'ease-out' }]]
});

export const FadeOut = velocityHelpers.registerEffect({
    calls: [[{ opacity: [0, 1] }, 1, { easing: 'ease-out' }]]
});

export const FlipXIn = velocityHelpers.registerEffect({
    calls: [[{ rotateX: [0, 90] }, 1, { easing: 'ease-out' }]]
});

export const FlipXOut = velocityHelpers.registerEffect({
    calls: [[{ rotateX: [-90, 0] }, 1, { easing: 'ease-out' }]]
});

export const BounceIn = velocityHelpers.registerEffect({
    calls: [[{ scale: [1, 0], opacity: [1, 0] }, 1, { easing: 'spring' }]]
});

export const BounceOut = velocityHelpers.registerEffect({
    calls: [[{ scale: [0, 1], opacity: [0, 1] }, 1, { easing: 'spring' }]]
});



// WEBPACK FOOTER //
// ./src/core/utils/velocity-animations.js